import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { SnAction } from '../../models';

@Component({
  selector: 'sn-action-list-item',
  templateUrl: './action-list-item.component.html',
  styleUrls: ['./action-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnActionListItemComponent {
  @Input()
  public item: SnAction;

  @Input()
  public context: any;

  constructor() {}

  public click(event: MouseEvent): void {
    event.stopPropagation();
    this.item.click(this.context);
  }
}
